import { Box, Chip, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export const questionnairePaperSx = {
  borderRadius: 3,
  overflow: 'hidden',
  bgcolor: '#f7fbff',
  boxShadow: '0 24px 70px rgba(0, 0, 0, 0.35)',
}

export const questionnaireDialogSx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
  },
}

export const questionnaireContentSx = {
  maxHeight: 'min(66vh, 680px)',
  overflowY: 'auto',
  px: { xs: 2.25, sm: 3 },
  py: 2.5,
  bgcolor: '#f7fbff',
}

export const questionnaireActionsSx = {
  px: { xs: 2.25, sm: 3 },
  py: 2,
  gap: 1,
  borderTop: '1px solid rgba(15, 40, 72, 0.08)',
  bgcolor: '#ffffff',
}

export const primaryActionSx = {
  borderRadius: 999,
  px: 2.4,
  py: 0.9,
  fontWeight: 800,
  textTransform: 'none',
  bgcolor: '#1468b7',
  '&:hover': { bgcolor: '#0d5598' },
}

export const secondaryActionSx = {
  borderRadius: 999,
  px: 2,
  py: 0.9,
  fontWeight: 800,
  textTransform: 'none',
  color: '#294765',
}

export function QuestionnaireTitle({ eyebrow, title, subtitle, step, total }) {
  return (
    <DialogTitle
      sx={{
        px: { xs: 2.25, sm: 3 },
        py: 2.4,
        color: '#10233f !important',
        bgcolor: '#ffffff',
        borderBottom: '1px solid rgba(15, 40, 72, 0.08)',
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" gap={2}>
        <Box>
          <Typography sx={{ color: '#1468b7', fontSize: 12, fontWeight: 850, textTransform: 'uppercase' }}>
            {eyebrow}
          </Typography>
          <Typography sx={{ color: '#10233f', fontSize: { xs: 22, sm: 27 }, fontWeight: 900, lineHeight: 1.12, mt: 0.5 }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography sx={{ color: '#5a6f86', fontSize: 14.5, mt: 0.9, maxWidth: 560 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {step && total && (
          <Chip
            label={`${step}/${total}`}
            sx={{
              bgcolor: '#e7f1fb',
              color: '#1468b7',
              fontWeight: 850,
              borderRadius: 2,
              mt: 0.4,
            }}
          />
        )}
      </Stack>
    </DialogTitle>
  )
}

export function QuestionBlock({ index, total, question, children }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  return (
    <Box
      sx={{
        p: { xs: 1.8, sm: 2.1 },
        mb: 1.6,
        borderRadius: 2,
        bgcolor: '#ffffff',
        border: '1px solid rgba(20, 104, 183, 0.12)',
        boxShadow: '0 10px 24px rgba(16, 35, 63, 0.05)',
      }}
    >
      <Typography sx={{ color: '#1468b7', fontSize: 12, fontWeight: 850, mb: 0.75 }}>
        {total
          ? t('monPatrimoine.questionOutOfTotal', { position: index + 1, total })
          : t('monPatrimoine.questionPosition', { position: index + 1 })}
      </Typography>
      <Typography sx={{ color: '#152b47', fontSize: 15.5, fontWeight: 750, lineHeight: 1.35 }}>
        {question}
      </Typography>
      <Box sx={{ mt: 1.2 }}>{children}</Box>
    </Box>
  )
}

export function ModernDialogContent({ children }) {
  return <DialogContent sx={questionnaireContentSx}>{children}</DialogContent>
}

export function ModernDialogActions({ children }) {
  return <DialogActions sx={questionnaireActionsSx}>{children}</DialogActions>
}
